import React from "react";

import { HStack, Stack, Text } from "@/components/ui";

import {
  GameStatus,
  HomeAwayLabel,
  LeagueBadge,
  TeamAvatar,
  TeamScore,
} from "./primitives";

import type { Team } from "@/schemas";
import type { SportGameDetails } from "@/schemas/sport-game";

const TeamColumn = ({
  team,
  side,
  align,
}: {
  team: Team;
  side: "home" | "away";
  align: "left" | "right";
}) => (
  <Stack className="w-16 min-w-0">
    <Text size="md" weight="medium" align={align} truncate>
      {team.abbreviation || team.name}
    </Text>
    <HomeAwayLabel side={side} align={align} />
  </Stack>
);

interface EmbedScorecardProps {
  event: SportGameDetails;
}

const EmbedScorecard = ({ event }: EmbedScorecardProps) => {
  const home = event.data.home_team;
  const away = event.data.away_team;

  return (
    <div className="rounded-2xl border p-4 lg:p-6">
      <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-3">
        <HStack alignItems="center" space={3} className="min-w-0">
          <TeamColumn team={home} side="home" align="right" />
          <TeamAvatar team={home} size="md" />
          <TeamScore value={home.score} align="center" className="min-w-8" />
        </HStack>

        <Stack space={2} alignItems="center" justifyContent="center">
          <LeagueBadge league={event.league} />
          <GameStatus data={event.data} />
        </Stack>

        <HStack alignItems="center" space={3} className="min-w-0 justify-end">
          <TeamScore value={away.score} align="center" className="min-w-8" />
          <TeamAvatar team={away} size="md" />
          <TeamColumn team={away} side="away" align="left" />
        </HStack>
      </div>
    </div>
  );
};

export default EmbedScorecard;
